import { sendMetricHostInstallDownload } from '../metrics';
import { createPeer, getPeer, getPersistentPlayerId } from '.';
import { joinIdState, deckState2, invitationState2, playerNameState, joinState } from './stores';
import config from '../config.json';
import { Invitation } from '@playcastdotio/Messaging';
import { queryInvitation, requestJoinInvitation } from './realtimeMessaging/handlers/invitationMessage';
import { sendAnalytics } from '@playcastdotio/Analytics';

export const onAlias = (invitations: Invitation[], name: string, greeting: string) => {
  deckState2.updateState({
    invitations,
    name,
    greeting,
  });
  invitationState2.updateState({
    ...invitationState2.currentState,
    success: true,
    invites: invitations.reduce((acc, invite) => {
      acc[invite.id] = invite;
      return acc;
    }, {}),
  });
  joinState.updateState({
    state: 'chooseDeck',
  });
};

export const onAliasUpdate = (updatedInvitation: Invitation) => {
  // Check if we have it already, if so update it, if not add it.
  const invites = deckState2.currentState.invitations;
  let added = false;
  const updatedInvites = invites.map((invite) => {
    if (invite.id === updatedInvitation.id) {
      added = true;
      return updatedInvitation;
    }
    return invite;
  });
  if (!added) {
    updatedInvites.push(updatedInvitation);
  }
  deckState2.updateState({
    ...deckState2.currentState,
    invitations: updatedInvites,
  });
};

export const onInviteQueryResponse = (invitationId: string, invitation?: Invitation) => {
  console.log('Invitation query response:', invitation);
  let didAdd = false;
  if (invitation !== undefined) {
    const exists = !!invitationState2.currentState.invites[invitationId];
    if (!exists) {
      didAdd = true;
    }
    invitationState2.updateState({
      ...invitationState2.currentState,
      invites: {
        [invitation.id]: invitation,
      },
    });
    // Also update active invitation if ids match
    if (invitationState2.currentState.selectedInvite?.id === invitation.id) {
      invitationState2.updateState({
        ...invitationState2.currentState,
        selectedInvite: invitation,
        success: true,
      });
    }
  } else {
    // remove the invite from the list
    const invites = invitationState2.currentState.invites;
    delete invites[invitationId];
    invitationState2.updateState({
      ...invitationState2.currentState,
      invites,
    });
    // set our selected invite to undefined if it was the one we were looking for
    if (invitationState2.currentState.selectedInvite?.id === invitationId) {
      invitationState2.updateState({
        ...invitationState2.currentState,
        selectedInvite: undefined,
        success: false,
      });
    }
    // do the same if our joinIdState matches the invitationId
    if (joinIdState.currentState === invitationId) {
      invitationState2.updateState({
        ...invitationState2.currentState,
        selectedInvite: undefined,
        success: false,
      });
      if (!invitationState2.currentState.isAlias) {
        joinState.updateState({
          state: 'chooseInvite',
        });
      }
    }
  }
  if (didAdd && !invitationState2.currentState.isAlias) {
    joinState.updateState({
      state: 'chooseInvite',
    });
  }
};

export const resolveJoinLink = async () => {
  const peer = getPeer();
  if (peer) {
    peer.close();
  }
  const joinId = joinIdState.currentState;
  queryInvitation(joinId);
};

export const refreshSelectedInvitation = async () => {
  const selectedInvite = invitationState2.currentState.selectedInvite;
  if (selectedInvite) {
    queryInvitation(selectedInvite.id);
  }
};

export const joinInvitation = async (invitation: Invitation) => {
  const displayName = playerNameState.currentState.name;
  requestJoinInvitation(invitation.id, displayName);
};

let lastPeerConnectedTimestamp = 0;
export const connectPeer = (broadcastSessionId: string) => {
  if (Date.now() - lastPeerConnectedTimestamp < 5000) {
    console.log('Ignoring connectPeer request');
    return;
  }
  if (!broadcastSessionId) {
    console.error('No broadcast session ID provided');
    return;
  }
  createPeer(broadcastSessionId);
  lastPeerConnectedTimestamp = Date.now();
  joinState.updateState({
    state: 'connecting',
  });
};

export const download = async () => {
  const userAgent = navigator.userAgent;
  let ipData = { ip: 'unknown' };

  try {
    const ipResponse = await fetch('https://api.ipify.org?format=json');
    ipData = await ipResponse.json();
    if (ipData.ip === undefined) {
      throw new Error('Failed to get IP address');
    }
  } catch (e) {
    console.error('Failed to get IP address', e);
    ipData = { ip: 'unknown' };
  }

  sendAnalytics({
    name: 'host-install-download',
    role: 'host',
    persistentId: getPersistentPlayerId(),
    userAgent: userAgent,
    ipAddress: ipData.ip,
  });
  window.open(config.DOWNLOAD_URL, '_self');
};
